import React, { useState, useRef, useEffect } from 'react';
import ReactPlayer from 'react-player';
import Modal from 'react-modal';
import useWindowSize from '@rooks/use-window-size';
import classnames from 'classnames/bind';

import { withSnapPoint } from '@components/snapping-slider';
import css from './video.module.scss';

const styles = classnames.bind(css);

const youtubeConfig = {
    youtube: {
        playerVars: {
            disablekb: 1,
            modestbranding: 1,
        },
    },
};

const VideoSlide = ({
    index,
    url,
    description,
    promptText = '',
    buttonText = 'Watch the video',
    createSnapPoint,
    Container,
    active,
    slideRef,
    isYoutubeVideo,
}) => {
    const [maximised, setMaximised] = useState(false);
    const { innerWidth, innerHeight } = useWindowSize();
    const togglePlayer = () => setMaximised(!maximised);
    const modalDimensions =
        innerWidth > 1.5 * innerHeight
            ? {
                  height: innerHeight - 250,
                  width: 16 * ((innerHeight - 250) / 9),
                  padding: 80,
                  top: 100,
              }
            : {
                  height: (innerWidth - 20) * (9 / 16),
                  width: innerWidth - 20,
                  left: 10,
                  top: 110,
              };

    const youtubeStyles = () => {
        if (!isYoutubeVideo) return {};

        // Expects 16:9 youtube video...
        const videoHeight = ((9 * innerWidth) / 16) - 140
        const scaleRatio = innerHeight / videoHeight

        return {
            transform: `scale(${scaleRatio})`,
        };
    };

    return (
        <div ref={slideRef} className={styles('video-slide')}>
            <Modal
                isOpen={maximised}
                ariaHideApp={true}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(28, 28, 28, 0.9)',
                        zIndex: 1,
                    },
                    content: {
                        ...modalDimensions,
                        margin: '0 auto',
                        padding: 0,
                        background: 'transparent',
                        border: 'none',
                        overflow: 'hidden',
                    },
                }}
                onRequestClose={togglePlayer}
            >
                <ReactPlayer url={url} controls playing={true} playsinline={true} tabIndex={-1} {...modalDimensions} />
            </Modal>

            <div className={styles('video-slide__prompt')}>
                <span className={styles('video-slide__text')}>{promptText}</span>
                <button
                    type="button"
                    tabIndex={0}
                    aria-label="Click button to play video"
                    onClick={togglePlayer}
                    className={styles('video-slide__button')}
                >
                    {buttonText}
                </button>
            </div>

            {/* We put an overlay here that is positioned ontop of image so touch doesn't interfere with video */}
            <div aria-hidden className={styles('video-slide__invisible-overlay')} />

            {/* Hack to get inert=true working */}
            <div ref={(node) => node && node.setAttribute('inert', '')}>
                <ReactPlayer
                    url={url}
                    controls={false}
                    ariaHideApp={true}
                    aria-hidden="true"
                    youtubeConfig={youtubeConfig}
                    playing={!maximised}
                    playsInline
                    muted
                    loop
                    style={{
                        pointerEvents: 'none',
                        position: 'relative',
                        ...youtubeStyles(),
                    }}
                    width={innerWidth}
                    height={innerHeight}
                />
            </div>
        </div>
    );
};

export default withSnapPoint(VideoSlide);
